export default __webpack_public_path__ + "static/rds-5f67a8d213d77841f4d5f451b94eebf1.svg";